var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Pie Chart")]),_c('div',{staticClass:"mt-4"},[_c('vue-apex-charts',{attrs:{"type":"pie","height":"350","options":_vm.apexChartData.pieChart.chartOptions,"series":_vm.apexChartData.pieChart.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }